import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material';
import InfoModal from 'src/components/InfoModal';
import InfoPopupContent from 'src/__mocks__/InfoPopupContent';

function dniCard(props) {
  const { value } = props;
  let displayValue = 'No Data';
  if (!Number.isNaN(value)) {
    displayValue = `${Number(value).toFixed(2)} kWh`;
  }

  const cardStyle = {
    display: "block",
    height: "100%"
  };

  return (
    <Card style={cardStyle}>
      <CardContent>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h6"
        >
          TOTAL INCIDENT ENERGY:
          <InfoModal content={InfoPopupContent.TOTAL_DNI} />
        </Typography>
        <Typography
          color="textSecondary"
          gutterBottom
          variant="h4"
        >
          <b>{ displayValue }</b>
        </Typography>  
      </CardContent>
    </Card>
  );
}

dniCard.propTypes = {
  value: PropTypes.number
};

export default dniCard;
